import isBlank from './Blank';

const isPresent = value => ! isBlank(value);

export default isPresent;
